module.exports = __webpack_public_path__ + "static/media/xk.18a00ce3.svg";